import { render, staticRenderFns } from "./StockCatalogs.vue?vue&type=template&id=b3e2e574"
import script from "./StockCatalogs.vue?vue&type=script&lang=js"
export * from "./StockCatalogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports